<template>
    <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from '../../components/cards/SubNavCard.vue'

export default {
  components: { SubNavCardVue },
  data() {
    return { 
      buttons: [
       
      ]
    }
  }
}
</script>
